import { notification } from 'antd';
import React from 'react';
import styled from 'styled-components';

import CrossSvg from '../assets/icons/CrossSvg';
import GreenCheckSvg from '../assets/icons/GreenCheckSvg';
import theme from '../assets/theme';

const CloseIcon = styled(CrossSvg)`
  color: ${theme.colors.greyDark};
  width: 14px;
  height: 14px;

  &:hover {
    color: ${theme.colors.black};
  }
`;

const successIcon = <GreenCheckSvg />;
const closeIcon = <CloseIcon />;

type NotificationOptions = Parameters<typeof notification.success>[0];

const showSuccessNotification = (options: NotificationOptions) => {
  notification.success({
    icon: successIcon,
    closeIcon,
    className: 'curipod-notification',
    duration: 3,
    ...options,
  });
};

const showErrorNotification = (options: NotificationOptions) => {
  notification.error({
    closeIcon,
    className: 'curipod-notification',
    duration: 4,
    ...options,
  });
};

const showInfoNotification = (options: NotificationOptions) => {
  notification.info({
    closeIcon,
    className: 'curipod-notification',
    duration: 3,
    ...options,
  });
};

export { showSuccessNotification, showErrorNotification, showInfoNotification };
